export const stackDict = {
	common: '/sprites/common-04a0f9e96b7cb7b6b72f7a993947c174.svg',
	linkedin: '/sprites/linkedin-1671459fea443390f144eab30dd8664d.svg'
}

type CommonIcon =
	| 'arrow'
	| 'arrow-double'
	| 'ascend'
	| 'clock'
	| 'close'
	| 'comp-network'
	| 'csv'
	| 'dollar'
	| 'export'
	| 'file'
	| 'filters'
	| 'gear'
	| 'info'
	| 'linked'
	| 'message'
	| 'plus'
	| 'sign-in'
	| 'trash'
	| 'user'
type LinkedinIcon = 'dots' | 'emoji'
export type { CommonIcon, LinkedinIcon }
